(function () {
    //Accessibility input placeholder
    (function (){
        const inputs = document.querySelectorAll('input');
        if (!inputs.length) return;
        const hoverActiveClass = 'input-hover';
        const notEmptyActiveClass = 'input-not-empty';

        inputs.forEach(inputEl => {
            inputEl.addEventListener('mouseenter', () => inputEl.closest('p')?.classList.add(hoverActiveClass))
            inputEl.addEventListener('focus', () => inputEl.closest('p')?.classList.add(hoverActiveClass))
            inputEl.addEventListener('mouseout', () => inputEl.closest('p')?.classList.remove(hoverActiveClass))
            inputEl.addEventListener('focusout', () => inputEl.closest('p')?.classList.remove(hoverActiveClass))

            inputEl.addEventListener('input', function (e) {
                if (e.target.value !== '') {
                    inputEl.closest('p')?.classList.add(notEmptyActiveClass)
                } else {
                    inputEl.closest('p')?.classList.remove(notEmptyActiveClass)
                }
            })
        })
    })();
})();